<template>
    <component
        :is="component"
        v-model="model"
        v-on="$listeners"
        v-bind="componentOptions"
    />
</template>

<script>
export default {
    name: 'oc-time-input',
    model: {
        prop: 'value',
        event: 'input'
    },
    props: {
        /**
         * Input value - used for v-model
         */
        value: {
            type: String,
            default: ''
        },
        variant: {
            type: String,
            default: 'cleave',
            validator: function (value) {
                return ['cleave'].indexOf(value) !== -1
            }
        }
    },
    data() {
        return {}
    },
    computed: {
        model: {
            get(){
                return this.value
            },
            set(val){
                this.$emit('input', val)
            }
        },
        component() {
            if( this.variant === 'cleave' ) {
                return 'oc-cleave'
            }
        },
        componentOptions() {
            if( this.variant === 'cleave' ) {
                return {
                    time: true,
                    raw: false
                }
            }
        }
    }
}
</script>
